// extracted by mini-css-extract-plugin
module.exports = {"loading":"App_loading__2MPR4","spin":"App_spin__3iKBf","App":"App_App__JnyK1","todos":"App_todos__LR0uE","todolist":"App_todolist__2dA_p"};